@if (!editingApiKey) {
  <div class="api-keys-header-container">
    <h3 class="header-title">API Keys</h3>
    <button class="primary-button" nz-button nzSize="default" nzType="primary" nzDanger [disabled]="true" (click)="openCreateModal(tplContent, tplFooter)">
      <span nz-icon nzType="plus" nzTheme="outline"></span>
      Add API key
    </button>
  </div>

  <div *ngIf="apiKeySecret" class="api-key-secret">
    <button nz-button nzType="default" [cdkCopyToClipboard]="apiKeySecret">
      <span nz-icon nzType="copy"></span>
    </button>
    <div>
      <div><strong>Copy the generated API key now — it won't be shown again</strong></div>
      <div class="secret-value">{{ apiKeySecret }}</div>
    </div>
  </div>

  <nz-table
    [nzLoading]="isLoading"
    [nzData]="apiKeys"
    [nzShowPagination]="false"
    [nzFrontPagination]="false"
    [nzSize]="'small'"
  >
    <thead>
    <tr>
      <th>Name</th>
      <th>Description</th>
      <th>Key</th>
      <th>Permissions</th>
      <th>Created at</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let apiKey of apiKeys">
      <td>{{ apiKey.name }}</td>
      <td>{{ apiKey.description }}</td>
      <td>{{ apiKey.full_api_key_alias }}</td>
      <td>{{ apiKey.permissions.join(', ') }}</td>
      <td>{{ apiKey.created_at | yomaDateFormat:'dd.MM.yyyy HH:mm' }}</td>
      <td class="actions-column">
        <button nz-button nzType="text" nz-tooltip="Edit API key" (click)="editApiKey(apiKey)">
          <span nz-icon nzType="edit"></span>
        </button>
        <button nz-button nzType="text" nz-tooltip="Delete API key" [disabled]="true" (click)="deleteApiKey(apiKey)">
          <span nz-icon nzType="delete"></span>
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>

  <ng-template #tplContent>
    <form nz-form>
      <nz-form-item>
        <nz-form-label class="feature-form-label" nzRequired>Name</nz-form-label>
        <nz-form-control nzHasFeedback nzErrorTip="Name is required">
          <input nz-input [(ngModel)]="newApiKey.name" name="api_key_name" required="true" placeholder="Name"/>
        </nz-form-control>
      </nz-form-item>
      <nz-form-label class="feature-form-label">Description</nz-form-label>
      <nz-form-item>
        <nz-form-control>
          <textarea nz-input [(ngModel)]="newApiKey.description" name="api_key_description" placeholder="Description" nzAutosize></textarea>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label class="feature-form-label" nzRequired>Permissions</nz-form-label>
        <nz-form-control>
          <nz-select nzMode="multiple" [(ngModel)]="newApiKey.permissions" name="api_key_permissions" nzPlaceHolder="Select permissions" style="width: 100%">
            <nz-option *ngFor="let permission of permissionOptions" [nzLabel]="permission" [nzValue]="permission"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <p class="divider"><span class="text">Metadata</span><span class="line"></span></p>
      <div class="metadata-list">
        <div class="metadata-row" *ngFor="let row of metadataRows; let i = index">
          <input nz-input [(ngModel)]="row.key" [name]="'metadata_key_' + i" placeholder="Key"/>
          <input nz-input [(ngModel)]="row.value" [name]="'metadata_value_' + i" placeholder="Value"/>
          <button nz-button nzType="text" (click)="removeMetadataRow(i)">
            <span nz-icon nzType="delete"></span>
          </button>
        </div>
        <button nz-button nzType="dashed" (click)="addMetadataRow()">
          <span nz-icon nzType="plus"></span>
          Add metadata field
        </button>
      </div>

      <p class="divider"><span class="text">Supplier metadata</span><span class="line"></span></p>
      <supplier-metadata-editor [customer]="customer" [entries]="supplierMetadata" (entriesChange)="supplierMetadata = $event"></supplier-metadata-editor>
    </form>
  </ng-template>

  <ng-template #tplFooter let-ref="modalRef">
    <button nz-button (click)="ref.destroy()" class="form-button">Cancel</button>
    <button
      [disabled]="isCreateDisabled()"
      nzType="primary"
      [nzLoading]="createKeyLoading"
      nz-button
      class="form-button"
      nzDanger
      (click)="create(ref)"
      >
      Generate
    </button>
  </ng-template>
} @else {
  <api-key-configuration [apiKey]="editingApiKey" [customer]="customer" (back)="back()"></api-key-configuration>
}
